import { history } from 'core/history';
import queryString from '@utils/query-string';
import { getRedirectUrl, getToken, bbtLogin } from './service';
import { TOKEN } from '@utils/constants';
import { isLogin, setToken, removeToken } from '@utils/userinfo';

/** 清空登录态 */
const clean = () => {
  /** replace url by remove code */
  const origin = window.location.href;
  let { query } = queryString.parseUrl(origin);
  try {
    if (query?.code) {
      delete query.code;
    }
  } catch (e) {}
  history.replace({
    pathname: window.location.pathname,
    search: queryString.stringify(query)
  });
  /** remove token */
  removeToken();
};

/**
 * 手动登录
 * @param {string} 当前url的code参数
 * @returns {boolean} 登录成功/失败
 */
const toLogin = async (code = '', redirectUrl, forceLogin = false) => {
  if (code) {
    return await handleLoginCode(code, false);
  } else {
    if (!forceLogin && isLogin()) {
      return true;
    } else {
      if (!code) {
        const url = await getRedirectUrl({
          recruitUrl: redirectUrl || window.location.href
        });
        console.log('#redirecturl#', url);
        if (url) {
          window.location.replace(url);
          return null;
        } else {
          return false;
        }
      } else {
        return await handleLoginCode(code, false);
      }
    }
  }
};

const handleLoginCode = async (code = '', forceLogin) => {
  const token = await getToken({ code });
  if (token) {
    setToken(token);
    /** 异步打通bbt账号登录 */
    bbtLogin({ loginString: token });

    const origin = window.location.href;
    let { query } = queryString.parseUrl(origin);
    try {
      if (query?.code) {
        delete query.code;
      }
      query['forceLogin'] = forceLogin ? 1 : 0;
    } catch (e) {}
    history.replace({
      pathname: window.location.pathname,
      search: queryString.stringify(query)
    });
    return true;
  } else {
    return false;
  }
};

export { TOKEN, clean, toLogin, isLogin };
